// extracted by mini-css-extract-plugin
module.exports = {"Heading":"form_Heading__Fxos4","Form":"form_Form__1FAvC","Question":"form_Question__3tZE7","ErrorMessage":"form_ErrorMessage__27lpR","Button":"form_Button__2ZfzL"};